import React, { lazy, Suspense } from 'react';

import maintenanceSvg from 'assets/maintenance.svg';

import { Spinner } from '@components/Spinner';
import { MAINTENANCE } from '@core/config';
import { ServerErrorLayout, SiteLayout } from '@layouts';

import { useMaintenanceQuery } from './queries.rest';

export function Maintenance({
  children,
}: {
  children: (isInMaintenance: boolean) => React.ReactNode;
}) {
  const { data, loading } = useMaintenanceQuery(MAINTENANCE);
  const showMaintenance =
    data?.site?.maintenanceMode === true && data?.site?.maintenanceAllowed === false;
  const isInMaintenance = MAINTENANCE || showMaintenance || loading;

  return isInMaintenance ? (
    <SiteLayout footer nav={false}>
      {loading ? (
        <Spinner big />
      ) : (
        <ServerErrorLayout
          image={<img src={maintenanceSvg} alt="Maintenance" />}
          headerText="Przerwa techniczna."
          subHeaderText="Zapraszamy wkrótce"
        />
      )}
    </SiteLayout>
  ) : (
    <>{children(isInMaintenance)}</>
  );
}
